import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, Sorting, SortDirection } from 'app/shared/lib/essette-site';
import { CaseService } from 'app/cm/services/case-service';
import { bindable } from 'aurelia-typed-observable-plugin';
import * as CM from 'app/cm/models/essette-api';
import { apiCall } from 'app/shared/lib/essette-api';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';

@autoinject()
export class CaseStatusHistoryGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected caseId: string | null = null;

    protected statuses: ReadonlyArray<CM.CaseStatusHistory> | undefined = undefined;

    private sorting: Sorting = new Sorting();
    protected resultCount: number = 0;
    protected pageSize: number = 25;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: CaseService,
        ...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////
    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
        //Call stop Propagation to prevent parent table from reload and losing sort
        event.stopPropagation();
    }


    ////****************** Functions ************************************************////
    public async reload(): Promise<void> {
        await this.loadStatusHistory();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    public async loadStatusHistory(): Promise<void> {
        if(!this.caseId) return;

        const includes: string[] = [
            'status',
            'status.reason',
            'metadata.started.byUser'
        ];
        const fields: string[] = [
            'metadata.started.byUser.description',
            'metadata.started.timestamp',
            'status.description',
            'status.reason.description',
        ];

        const options: Partial<IQueryLoadOptions> = {
            includeInactive: false,
            sorting: this.sorting,
            page: this.$pager?.page || 0,
            top: this.pageSize
        };

        try {
            this.state.beginLoad();
            const response = await this.service.loadCaseStatusHistory(this.caseId, options, includes, fields);
            this.statuses = response.results;
            this.resultCount = response.count || 0;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
